const calculateMonthsSinceDate = (date: Date): number => {
  const today = new Date();
  const diffTime = Math.abs(today.getTime() - date.getTime());
  const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30);
  return diffMonths;
};

export default calculateMonthsSinceDate;
